import PropTypes from 'prop-types';

const RoomDescription = ({ description }) => {
  if (!description) return <p>No description found</p>;
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </>
  );
};

RoomDescription.propTypes = {
  description: PropTypes.string,
};

RoomDescription.defaultProps = {
  description: '',
};

export default RoomDescription;
